import { PendingPaymentInfo } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

export const useFetchPendingPayments = () => {
  const fetchPendingPayments = async () => {
    const res = await medicareApiClient.premiumsApi.getPremiumsPendingPayments()
    return res.data
  }

  return useQuery<PendingPaymentInfo[] | undefined>(
    'PendingPayments',
    fetchPendingPayments,
    {
      retry: false,
      refetchOnWindowFocus: false
    }
  )
}
